export { Ng2FileInputComponent } from './src/ng2-file-input.component';
export { FileInputHandlerService } from './src/file-input-handler.service';
export { Ng2FileInputService } from './src/ng2-file-input.service';
export { Ng2FileInputOptions } from './src/ng2-file-input-options.class';
export { Ng2FileInputAction } from './src/ng2-file-input-action.enum';
export { Ng2FileInputModule } from './src/ng2-file-input.module';
//# sourceMappingURL=ng2-file-input.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-file-input/dist/ng2-file-input.js
// module id = ./node_modules/ng2-file-input/dist/ng2-file-input.js
// module chunks = vendor